import {Button, Paper, Snackbar, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useTenant} from "../context/tenant";
import {useLocalization} from "../i18n";

const CONSENT_KEY = "safecube-cookie-consent";

function hasDecided(): boolean {
	return localStorage.getItem(CONSENT_KEY) !== null;
}

export function hasCookieConsent(): boolean {
	const params = new URLSearchParams(window.location.search);
	if (params.has("cookiesAlreadyAccepted")) {
		return true;
	}
	return localStorage.getItem(CONSENT_KEY) === "true";
}

export function CookieConsentBanner() {
	const {t} = useLocalization();
	const {tenant} = useTenant();
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (tenant?.trackingCode && !hasDecided() && !hasCookieConsent()) {
			setOpen(true);
		}
	}, [tenant?.trackingCode]);

	function handleAccept() {
		localStorage.setItem(CONSENT_KEY, "true");
		setOpen(false);
		// Dispatch a storage event so TrackingCodeInjector can react
		window.dispatchEvent(new Event("cookie-consent-changed"));
	}

	function handleDecline() {
		localStorage.setItem(CONSENT_KEY, "false");
		setOpen(false);
	}

	if (!tenant?.trackingCode) {
		return null;
	}

	return (
		<Snackbar
			open={open}
			anchorOrigin={{vertical: "bottom", horizontal: "center"}}
		>
			<Paper elevation={6} sx={{p: 2, display: "flex", alignItems: "center", gap: 2, maxWidth: 600}}>
				<Typography variant="body2" sx={{flex: 1}}>
					{t("cookies.message")}
				</Typography>
				<Button variant="outlined" color="inherit" onClick={handleDecline} size="small">
					{t("cookies.decline")}
				</Button>
				<Button variant="contained" color="primary" onClick={handleAccept} size="small">
					{t("cookies.accept")}
				</Button>
			</Paper>
		</Snackbar>
	);
}
